export const urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict'



//////////////////
// WEBPACK FOOTER
// ./node_modules/nanoid/url-alphabet/index.js
// module id = 105
// module chunks = 3